import React from 'react';
import { FormattedMessage, useIntl, defineMessages } from 'react-intl';
import HelloModal from 'common/components/hello-modal';
import Logo from 'common/components/logo';
import styles from './high-resolution-fax-modal.scss';

type Props = {
  isOpen: boolean,
  close: any,
};

const modalPropMessages = defineMessages({
  title: {
    id: '',
    description: 'Title for high resolution and color fax info modal',
    defaultMessage: 'High resolution and color fax details',
  },
});

export default function HighResolutionFaxModal({ isOpen, close }: Props) {
  const intl = useIntl();
  return (
    <HelloModal
      width={'650px'}
      scrollable={false}
      isOpen={isOpen}
      onRequestClose={close}
      contentLabel={intl.formatMessage(modalPropMessages.title)}
    >
      <FormattedMessage
        id=""
        description="text for a modal on prep and send that says
        that the high resolution page recipient will look like the example below. An access code will let them download the high resolution and color copy."
        defaultMessage="Your fax will include a page like the one shown below.
        The recipient can use the access code to download a high resolution and color copy of the fax." />
      <br /><br />
      <FormattedMessage
        id=""
        description="text for a modal on Hellofax prep and send that says the link will be disabled in 72 hours"
        defaultMessage="Unless claimed, the link will be disabled after 72 hours." />
      <section className={styles.dummyDocument}>
        <div className={styles.dummyLogoContainer}>
          <Logo siteCode={'F'} isLink={false} />
        </div>

        <br /><br />
        To view a High Resolution & Color copy of this fax:
        <br /><br />
        1. Go to www.hellofax.com/HighRes
        <br /><br />
        2. Login or create a HelloFax account
        <br /><br />
        3. Enter Access Code: <div className={styles.accessCode}>5aaaf27d8b</div>
      </section>

    </HelloModal>
  );
}
